import { images } from '../constants';

export const training = [ 
    {
        id: 1,
        title: "training.item1.title",
        subtitle: "training.item1.subtitle",
        image: images.training1, 

        // Kluczowe szczegóły do Sidebara
        details: {
            duration: 'training.item1.details.duration',
            level: 'training.item1.details.level',
            deadline: 'training.item1.details.deadline',
        },

        goals: [
            "training.item1.goals.0",
            "training.item1.goals.1",
            "training.item1.goals.2",
            "training.item1.goals.3"
        ],

        outcomes: [
            "training.item1.outcomes.0",
            "training.item1.outcomes.1",
            "training.item1.outcomes.2"
        ],

        targetAudience: [
            "training.item1.targetAudience.0",
            "training.item1.targetAudience.1",
            "training.item1.targetAudience.2",
            "training.item1.targetAudience.3",
            "training.item1.targetAudience.4"
        ],

        program: [
            {
                title: "training.item1.program.0.title",
                points: [
                    "training.item1.program.0.points.0",
                    "training.item1.program.0.points.1",
                    "training.item1.program.0.points.2",
                    "training.item1.program.0.points.3"
                ]
            },
            {
                title: "training.item1.program.1.title",
                points: [
                    "training.item1.program.1.points.0",
                    "training.item1.program.1.points.1",
                    "training.item1.program.1.points.2",
                    "training.item1.program.1.points.3"
                ]
            },
            {
                title: "training.item1.program.2.title",
                points: [
                    "training.item1.program.2.points.0",
                    "training.item1.program.2.points.1",
                    "training.item1.program.2.points.2",
                    "training.item1.program.2.points.3"
                ]
            },
            {
                title: "training.item1.program.3.title",
                points: [
                    "training.item1.program.3.points.0",
                    "training.item1.program.3.points.1",
                    "training.item1.program.3.points.2",
                    "training.item1.program.3.points.3"
                ]
            },
            {
                title: "training.item1.program.4.title",
                points: [
                    "training.item1.program.4.points.0",
                    "training.item1.program.4.points.1",
                    "training.item1.program.4.points.2",
                    "training.item1.program.4.points.3"
                ]
            }
        ],

        methods: [
            "training.item1.methods.0",
            "training.item1.methods.1",
            "training.item1.methods.2",
            "training.item1.methods.3"
        ]
    },
    {
        id: 2,
        title: "training.item2.title",
        subtitle: "training.item2.subtitle",
        image: images.training2,

        details: {
            duration: 'training.item2.details.duration',
            level: 'training.item2.details.level',
            deadline: 'training.item2.details.deadline',
        },

        goals: [
            "training.item2.goals.0",
            "training.item2.goals.1",
            "training.item2.goals.2",
            "training.item2.goals.3",
            "training.item2.goals.4"
        ],

        outcomes: [
            "training.item2.outcomes.0",
            "training.item2.outcomes.1",
            "training.item2.outcomes.2",
            "training.item2.outcomes.3"
        ],

        targetAudience: [
            "training.item2.targetAudience.0",
            "training.item2.targetAudience.1",
            "training.item2.targetAudience.2",
            "training.item2.targetAudience.3",
            "training.item2.targetAudience.4"
        ],

        program: [
            {
                title: "training.item2.program.0.title",
                points: [
                    "training.item2.program.0.points.0",
                    "training.item2.program.0.points.1",
                    "training.item2.program.0.points.2",
                    "training.item2.program.0.points.3"
                ]
            },
            {
                title: "training.item2.program.1.title",
                points: [
                    "training.item2.program.1.points.0",
                    "training.item2.program.1.points.1",
                    "training.item2.program.1.points.2",
                    "training.item2.program.1.points.3"
                ]
            },
            {
                title: "training.item2.program.2.title",
                points: [
                    "training.item2.program.2.points.0",
                    "training.item2.program.2.points.1",
                    "training.item2.program.2.points.2"
                ]
            },
            {
                title: "training.item2.program.3.title",
                points: [
                    "training.item2.program.3.points.0",
                    "training.item2.program.3.points.1",
                    "training.item2.program.3.points.2"
                ]
            },
            {
                title: "training.item2.program.4.title",
                points: [
                    "training.item2.program.4.points.0",
                    "training.item2.program.4.points.1",
                    "training.item2.program.4.points.2",
                    "training.item2.program.4.points.3"
                ]
            }
        ],

        methods: [
            "training.item2.methods.0",
            "training.item2.methods.1",
            "training.item2.methods.2",
            "training.item2.methods.3"
        ]
    }
];

export default training;